import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, isRef as _isRef, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center" }
const _hoisted_2 = { class: "flex flex-col items-center w-full max-w-none h-full" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col items-center justify-between w-full h-full pb-[120px]"
}
const _hoisted_4 = { class: "flex flex-col items-center justify-center" }
const _hoisted_5 = {
  for: "paymentMethodCountry",
  class: "text-base2 text-center block"
}
const _hoisted_6 = {
  key: 0,
  id: "wallet-select-dropdown",
  class: "relative w-full max-w-[300px] mx-auto mb-4"
}
const _hoisted_7 = { class: "text-base2 text-center block mb-1" }
const _hoisted_8 = {
  key: 0,
  class: "absolute z-10 w-full mt-1 bg-black rounded max-h-60 overflow-auto"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "w-full mb-2" }
const _hoisted_11 = {
  key: 1,
  class: "mb-6 flex flex-col items-start justify-center p-4 font-sourcesanspro-regular rounded-md bg-white/10 small font-sourcesanspro-regular text-base2 text-white"
}
const _hoisted_12 = { class: "mb-1 font-extrabold" }
const _hoisted_13 = {
  key: 2,
  class: "mb-3 text-sm2 leading-[18px] font-sourcesanspro-semibold text-white"
}
const _hoisted_14 = {
  key: 3,
  class: "p-4 rounded-md bg-white/5 text-white/60"
}
const _hoisted_15 = {
  key: 1,
  class: "flex p-4 items-center justify-center max-w-[600px]"
}
const _hoisted_16 = {
  key: 2,
  class: "flex flex-col items-center justify-start max-w-[600px]"
}
const _hoisted_17 = {
  key: 0,
  class: "flex items-start justify-center"
}
const _hoisted_18 = { class: "font-sourcesanspro-regular text-[40px] mr-2 leading-[52px]" }
const _hoisted_19 = { class: "mx-1" }
const _hoisted_20 = { class: "flex flex-col items-center justify-start font-color-text-50" }
const _hoisted_21 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_22 = { class: "font-sourcesanspro-regular text-l2" }
const _hoisted_23 = {
  key: 0,
  class: "text-white/50 text-sm block text-center"
}
const _hoisted_24 = {
  key: 1,
  class: "w-[249px] px-1 text-center font-sourcesanspro-regular text-base2 leading-[26px] whitespace-nowrap"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  key: 3,
  class: "flex flex-col w-full max-w-[600px] align-center"
}
const _hoisted_28 = {
  key: 0,
  class: "flex flex-col items-center mb-8"
}
const _hoisted_29 = { class: "mb-4" }
const _hoisted_30 = { class: "font-sourcesanspro-regular text-sm2" }
const _hoisted_31 = { class: "flex mb-4" }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "flex min-w-0 flex-col text-left leading-[18px]" }
const _hoisted_34 = { class: "font-sourcesanspro-bold text-sm2" }
const _hoisted_35 = { class: "font-sourcesanspro-semibold text-xs2 text-white/90" }
const _hoisted_36 = { class: "fixed bottom-0 left-0 right-0 bg-white/20 backdrop-blur z-10 px-0" }
const _hoisted_37 = {
  key: 0,
  class: "flex w-full items-center justify-between"
}
const _hoisted_38 = {
  key: 1,
  class: "flex w-full items-center justify-between"
}
const _hoisted_39 = ["src"]
const _hoisted_40 = {
  key: 2,
  class: "flex w-full items-center justify-center gap-2"
}
const _hoisted_41 = { class: "click-to-pay-modal" }
const _hoisted_42 = { class: "flex items-center justify-between mb-4" }
const _hoisted_43 = { class: "font-sourcesanspro-black text-m2 text-black" }
const _hoisted_44 = { class: "click-to-pay-modal-callout" }
const _hoisted_45 = { class: "click-to-pay-modal-list" }
const _hoisted_46 = { class: "click-to-pay-modal-footer" }

import { computed, onMounted, ref, watch, onUnmounted } from 'vue';
import router from '@/router';
import { useRoute } from 'vue-router';
import { IonButton, IonContent, IonIcon, IonLabel, IonModal, IonSegment, IonSegmentButton, IonSpinner } from '@ionic/vue';
import { TopUp } from '@/enums/values.enum';
import { arrowForwardOutline, chevronBackOutline, chevronDown as chevronDownIcon, chevronForwardOutline, closeOutline } from 'ionicons/icons';
import { useI18n } from 'vue-i18n';

import { TransactionType, TransactionSubtype } from '@/enums/wallet.enum';
import { useSharedStore } from '@/stores/shared/sharedStore';
import { useTransactionStore } from '@/stores/transaction/transactionStore';
import { WalletPackage } from '@/shared/interfaces/wallet';
import hexRgb from 'hex-rgb';
import ItemWithContentStandalone from '@/shared/components/ui/ItemWithContentStandalone.vue';
import rgbHex from 'rgb-hex';
import searchUser from '@/modules/guest/composables/useGuestUser';
import TopBar from '@/shared/components/TopBar.vue';
import type { Transaction } from '@/shared/interfaces/transaction';
import useRfidGuest from '@/modules/rfid/composables/useRfidGuest';
import useTenant from '@/shared/composables/useTenant';
import useTopUp from '@/modules/top-up/composables/useTopUp';
import useUserProfile from '@/modules/profile/composables/useUserProfile';
import useUtils from '@/shared/composables/useUtils';
import useWallet from '@/modules/wallet/composables/useWallet';
import useCurrencies from '@/shared/composables/useCurrencies';
import CurrencyInput from '@/shared/components/sign-up-forms/CurrencyInput.vue';
import CountrySelect from '@/shared/components/countries/CountrySelect.vue';
import useStorageService from '@/shared/composables/useStorageService';
import type { PreferredPaymentMode } from '@/modules/top-up/composables/useTopUp';

// Init

export default /*@__PURE__*/_defineComponent({
  __name: 'TopUpPage',
  setup(__props) {

const { t } = useI18n();
const route = useRoute();
const encryptedRfidTag = route.query.id?.toString();
const loginToken = route.query.loginToken?.toString() || '';
const walletId = route.params.wallet_id?.toString();
const backToDashboard = route.query.backToDashboard?.toString();
const transactionStore = useTransactionStore();
const { setItemsAndTotal } = transactionStore;
const { getPackages, getMinimumTopUpAmount, getPreviousTopUpAmount, selectedWallet } = useWallet();
const effectiveWalletId = computed(() => selectedWallet.value?.id?.toString() || walletId);
const { minimumTopUp } = getMinimumTopUpAmount(effectiveWalletId);
const { previousTopUp } = getPreviousTopUpAmount(effectiveWalletId, encryptedRfidTag || loginToken ? ref(false) : ref(true));
const { walletPackages } = getPackages(effectiveWalletId);
const { getTenantConfigAndStyles } = useTenant();
const { tenantConfig } = getTenantConfigAndStyles();
const { calculateShade, convertToCurrency, replaceTopUpGeneralMessageVariables } = useUtils();
const primary_color = window.primary_color;
const primaryRgb = hexRgb(window.primary_color, { format: 'array' });
const primaryShade = '#' + rgbHex(calculateShade(primaryRgb.toString(), 0.2));
const selectedWalletPackage = ref();
const showClickToPayInfoModal = ref(false);
const { getWalletBalance } = useRfidGuest();
const { refetchWalletBalanceData, walletBalanceData } = getWalletBalance(encryptedRfidTag);
const { fiatCurrency } = useCurrencies();
const { get, set } = useStorageService();

const { availablePaymentCountries, checkIsLatestAmountGreaterThanMinimumAmount, enableTopUpSubmitButton, formValue, minimumAmountError, onAmountChange, paymentMethodCountry, switchPreferredPaymentMode, countrySelectionValidated, getApplicablePaymentCountry, startTopUp, selectTopUp } = useTopUp(tenantConfig, minimumTopUp);
const { getUserProfile } = useUserProfile();
const { userProfile } = getUserProfile();
const sharedStore = useSharedStore();
const { getWallets } = useWallet();
const { wallets } = getWallets();
const { guestUserProfile, userMutate } = searchUser();
const topUpType = ref('');
const topupableWallets = computed(() => wallets.value?.filter((w) => w.currency.topupable) || []);
const configuredPreferredPaymentMode = computed<PreferredPaymentMode>(() => {
	if (tenantConfig.value?.viva_wallet_click_to_pay_preferred_mode) return 'click_to_pay';
	if (tenantConfig.value?.viva_wallet_payconiq_preferred_mode) return 'payconiq';
	return null;
});
const activePreferredPaymentMode = computed<PreferredPaymentMode>(() => (sharedStore.shouldUsePreferredPaymentMode ? configuredPreferredPaymentMode.value : null));
const isPayconiqPreferredModeActive = computed(() => activePreferredPaymentMode.value === 'payconiq');
const isClickToPayPreferredModeActive = computed(() => activePreferredPaymentMode.value === 'click_to_pay');
const isPreferredPaymentModeActive = computed(() => !!activePreferredPaymentMode.value);
const shouldSkipOverviewForPreferredPayment = computed(() => {
	const topUpCost = Number(tenantConfig.value?.top_up_cost) || 0;
	const cardCreationCost = Number(tenantConfig.value?.top_up_card_creation_cost) || 0;

	return isPreferredPaymentModeActive.value && topUpCost === 0 && (!tenantConfig.value?.top_up_card_creation_cost_to_customer || cardCreationCost === 0);
});

watch(
	[guestUserProfile],
	() => {
		if (loginToken && guestUserProfile.value) {
			selectedWallet.value = guestUserProfile.value?.wallets.find((wallet) => wallet.id === +walletId);
		}
	},
	{ immediate: true },
);

onMounted(async () => {
	window.addEventListener('keydown', handleEnterKey);
	window.addEventListener('click', closeWalletSelectOnOutsideClick);
	if (loginToken) {
		userMutate({ login_token: loginToken });
	}

	const autoContinue = route.query.autoContinue === 'true';

	// Reset state - only set preferred mode if not coming from quick topup
	if (!autoContinue) {
		sharedStore.shouldUsePayconiq = true;
		sharedStore.shouldUsePreferredPaymentMode = true;
	}

	if (tenantConfig && tenantConfig.value && tenantConfig.value.wallet_enable_packages) {
		topUpType.value = TopUp.TopUpTypePackages;
	} else {
		topUpType.value = TopUp.TopUpTypeFreeAmount;
	}

	const queryPackageId = route.query.packageId ? +route.query.packageId : 0;

	watch(
		() => [walletPackages.value, queryPackageId],
		([packages, pkgId]) => {
			if (pkgId && packages && packages.length > 0) {
				const found = packages.find((p: WalletPackage) => p.id === pkgId);
				if (found && (!selectedWalletPackage.value || selectedWalletPackage.value.id !== found.id)) {
					console.log('[TopUpPage] Auto-selecting package from query param:', found.name, found.id);
					selectPackage(found);
					if (autoContinue) {
						console.log('[TopUpPage] autoContinue=true, will call addTopUpPackage after nextTick');
						setTimeout(() => {
							console.log('[TopUpPage] autoContinue executing addTopUpPackage');
							console.log('[TopUpPage] State before addTopUpPackage:', {
								selectedWalletPackage: selectedWalletPackage.value?.id,
								shouldSkipOverview: shouldSkipOverviewForPreferredPayment.value,
								activePreferredPaymentMode: activePreferredPaymentMode.value,
								sharedStore_shouldUsePreferredPaymentMode: sharedStore.shouldUsePreferredPaymentMode,
								sharedStore_shouldUsePayconiq: sharedStore.shouldUsePayconiq,
							});
							addTopUpPackage();
						}, 500);
					}
				}
			}
		},
		{ immediate: true },
	);

	if (encryptedRfidTag) {
		await refetchWalletBalanceData();
		selectedWallet.value = walletBalanceData.value?.wallets.find((wallet) => wallet.id === +walletId);
	} else if (loginToken) {
		// use mutation to get user profile
	} else {
		if (wallets.value?.length) {
			if (walletId) {
				selectedWallet.value = wallets.value.find((w) => w.id.toString() === walletId);
			}
			if (!selectedWallet.value) {
				selectedWallet.value = wallets.value.find((w) => w.currency.topupable && w.currency.default) || wallets.value.find((w) => w.currency.topupable) || wallets.value[0];
			}
		}
	}
});

onUnmounted(() => {
	window.removeEventListener('keydown', handleEnterKey);
	window.removeEventListener('click', closeWalletSelectOnOutsideClick);
});

const closeWalletSelectOnOutsideClick = (e: MouseEvent) => {
	const path = e.composedPath?.() || [];
	if (!path.some((el: any) => el?.id === 'wallet-select-dropdown') && isWalletSelectOpen.value) {
		isWalletSelectOpen.value = false;
	}
};

const isWalletSelectOpen = ref(false);

const toggleWalletSelect = () => {
	isWalletSelectOpen.value = !isWalletSelectOpen.value;
};

const onWalletSelect = (newWalletId: string) => {
	const wallet = wallets.value?.find((w) => w.id.toString() === newWalletId);
	if (wallet) {
		selectedWallet.value = wallet;
	}
	isWalletSelectOpen.value = false;
};

watch(selectedWallet, () => {
	formValue.value = '0,00';
	selectedWalletPackage.value = undefined;
	enableTopUpSubmitButton.value = false;
	minimumAmountError.value = false;
});

// selectPackage
const selectPackage = (walletPackage: WalletPackage) => {
	if (selectedWalletPackage.value === undefined || selectedWalletPackage.value !== walletPackage) {
		const walletItems: any = [
			{
				description: `${walletPackage.name}`,
				currency: '€',
				itemPrice: +walletPackage.clientx_price,
				quantity: 1,
				hideQuantiy: true,
				hidePrice: false,
			},
		];

		let totalPriceString = '';
		let totalPriceNumber = 0;

		// Include administrative fee if applicable
		if (walletPackage.clientx_price_incl_fee > +walletPackage.clientx_price) {
			const fee = walletPackage.clientx_price_incl_fee - +walletPackage.clientx_price;
			walletItems.push({
				description: t('transaction.administrative_fee'),
				currency: '€',
				itemPrice: fee,
				quantity: 1,
				hideQuantiy: true,
				hidePrice: false,
			});
			totalPriceNumber = walletPackage.clientx_price_incl_fee;
		} else {
			totalPriceNumber = +walletPackage.clientx_price;
		}

		totalPriceString = `€${totalPriceNumber.toFixed(2)}`;

		const transaction: Transaction = {
			additionalInfo: {
				isGuestTopUp: !!(encryptedRfidTag || loginToken),
				encryptedRfidTag,
				redirectPath: encryptedRfidTag ? `/wallet/wallet-handler/${encryptedRfidTag}` : '/dashboard',
				packageContents: walletPackage.contents,
			},
			items: [...walletItems],
			totalDescription: `${t('transaction.total')}`,
			totalPriceString,
			totalPriceNumber,
			totalPriceWithoutFee: +walletPackage.clientx_price,
			type: TransactionType.TOP_UP,
			subtype: TransactionSubtype.PACKAGE,
		};

		setItemsAndTotal(transaction);
		selectedWalletPackage.value = walletPackage;
	} else {
		selectedWalletPackage.value = undefined;
	}
};

const goToTopUpOverview = () => {
	router.push({
		name: 'top-up-overview',
		params: { wallet_id: effectiveWalletId.value },
		query: {
			id: encryptedRfidTag,
			loginToken,
			backToDashboard,
			packageId: selectedWalletPackage.value?.id,
			amount: formValue.value,
			topUpType: topUpType.value,
		},
	});
};

const addTopUp = async () => {
	const amountDecimal = parseFloat(formValue.value.replace(',', '.'));
	const tokenAmount = selectedWallet.value?.currency.name === 'EUR' ? amountDecimal : +(amountDecimal / +selectedWallet.value.currency.exchange_rate).toFixed(2);
	const totalAmountWithoutFee = tokenAmount;

	if (topUpType.value === TopUp.TopUpTypeFreeAmount && amountDecimal > 0 && selectedWallet.value?.currency) {
		const tokenDisplay = selectedWallet.value.currency.name === 'EUR'
			? amountDecimal.toFixed(2)
			: (amountDecimal / +selectedWallet.value.currency.exchange_rate).toFixed(2);

		const items = [
			{
				description: `${selectedWallet.value.currency.prefix} ${tokenDisplay} ${selectedWallet.value.currency.name}`,
				itemPrice: +amountDecimal,
				quantity: 1,
				currency: '€',
			},
		];
		if (+tenantConfig.value!.top_up_cost > 0) {
			items.push({
				description: t('transaction.administrative_fee'),
				itemPrice: +tenantConfig.value!.top_up_cost,
				quantity: 1,
				currency: '€',
			});
		}

		const topUpAmountWithTopUpCost = +amountDecimal + (tenantConfig.value?.top_up_cost ? +tenantConfig.value.top_up_cost : 0);

		const tokenTitle = selectedWallet.value.currency.name === 'EUR'
			? `€ ${amountDecimal}`
			: `${selectedWallet.value.currency.prefix} ${(amountDecimal / +selectedWallet.value.currency.exchange_rate).toFixed(2)} ${selectedWallet.value.currency.name}`;

		const transaction: Transaction = {
			additionalInfo: {
				isGuestTopUp: !!(encryptedRfidTag || loginToken),
				encryptedRfidTag,
				redirectPath: encryptedRfidTag ? `/wallet/wallet-handler/${encryptedRfidTag}` : '/dashboard',
			},
			title: tokenTitle,
			items,
			totalDescription: t('transaction.total'),
			totalPriceString: `€${topUpAmountWithTopUpCost.toFixed(2)}`,
			totalPriceNumber: topUpAmountWithTopUpCost,
			totalPriceWithoutFee: totalAmountWithoutFee,
			type: TransactionType.TOP_UP,
			subtype: TransactionSubtype.FREE_AMOUNT,
			walletId: effectiveWalletId.value,
		};

		setItemsAndTotal(transaction);

		// Check if we should skip overview and go directly to checkout
		const shouldSkipOverview = shouldSkipOverviewForPreferredPayment.value;

		console.log('Skip overview conditions:', {
			preferredPaymentMode: activePreferredPaymentMode.value,
			shouldUsePreferredPaymentMode: sharedStore.shouldUsePreferredPaymentMode,
			topUpCost: tenantConfig.value?.top_up_cost,
			cardCreationCostToCustomer: tenantConfig.value?.top_up_card_creation_cost_to_customer,
			cardCreationCost: tenantConfig.value?.top_up_card_creation_cost,
			shouldSkip: shouldSkipOverview,
		});

		if (shouldSkipOverview) {
			// Check if minimum amount data is loaded, if not fall back to overview
			if (!minimumTopUp.value || minimumTopUp.value.amount === undefined) {
				console.log('Minimum top-up data not loaded yet, going to overview');
				goToTopUpOverview();
				return;
			}

			const minimumLocalAmount = minimumTopUp.value.amount;
			const topUpCost = Number(tenantConfig.value.top_up_cost) || 0;
			const totalAmount = Number((amountDecimal + topUpCost).toFixed(2));

			let respectsMinimums = false;
			if (minimumLocalAmount > 0) {
				respectsMinimums = amountDecimal >= minimumLocalAmount && totalAmount >= 1;
			} else {
				respectsMinimums = totalAmount >= 1;
			}

			console.log('Validation result:', { respectsMinimums });

			if (!respectsMinimums) {
				// Don't skip if minimum requirements not met, go to overview to show error
				console.log('Minimum amount validation failed, going to overview');
				goToTopUpOverview();
				return;
			}

			// The formValue should remain as the user's input amount (local currency format)
			// startTopUp will handle the conversion and formatting for the API

			// Start the top-up directly
			const paymentMethodCountry = getApplicablePaymentCountry();

			if (!selectedWallet.value) {
				selectedWallet.value = await get('selectedWallet');
			}

			startTopUp(paymentMethodCountry, activePreferredPaymentMode.value, encryptedRfidTag, effectiveWalletId.value, selectedWallet.value?.currency.id, loginToken);
			return;
		}
	}

	goToTopUpOverview();
};

const addTopUpPackage = () => {
	// Check if we should skip overview and go directly to checkout
	const shouldSkipOverview = shouldSkipOverviewForPreferredPayment.value;

	if (shouldSkipOverview && selectedWalletPackage.value) {
		// Start the package top-up directly
		const paymentMethodCountry = getApplicablePaymentCountry();

		selectTopUp(selectedWalletPackage.value.id, paymentMethodCountry, activePreferredPaymentMode.value, encryptedRfidTag, loginToken);
		return;
	}

	goToTopUpOverview();
};

// Go back
const goBack = () => {
	if (backToDashboard === 'true') {
		router.push('/dashboard');
	} else {
		router.back();
	}
};

const handleEnterKey = (event: KeyboardEvent) => {
	if (event.key === 'Enter') {
		if (topUpType.value === TopUp.TopUpTypeFreeAmount && enableTopUpSubmitButton.value) {
			addTopUp();
		} else if (topUpType.value === TopUp.TopUpTypePackages && selectedWalletPackage.value) {
			addTopUpPackage();
		}
	}
};

return (_ctx: any,_cache: any) => {
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createBlock(_unref(IonContent), {
    style: _normalizeStyle(`background: linear-gradient(${_unref(primary_color)}, ${primaryShade});`),
    class: _normalizeClass([
			{
				'payconiq': isPayconiqPreferredModeActive.value,
				'click-to-pay': isClickToPayPreferredModeActive.value,
			},
		])
  }, {
    default: _withCtx(() => [
      _createVNode(TopBar, { class: "px-[34px]" }, {
        left: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(IonButton), {
              class: _normalizeClass(["w-[35px] h-[35px] text-black ion-no-padding ion-no-margin hover:bg-white hover:rounded-full", { 'preferred-back-button': isPreferredPaymentModeActive.value }]),
              shape: "round",
              onClick: goBack
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonIcon), {
                  icon: _unref(chevronBackOutline),
                  class: _normalizeClass(["ion-no-padding ion-no-margin mr-[2px]", isPreferredPaymentModeActive.value ? 'preferred-back-icon' : 'text-black'])
                }, null, 8, ["icon", "class"])
              ]),
              _: 1
            }, 8, ["class"])
          ])
        ]),
        center: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["flex justify-center w-full font-sourcesanspro-semibold text-l2", { 'text-white': isPreferredPaymentModeActive.value }])
          }, _toDisplayString(_unref(t)('topup.title')), 3)
        ]),
        right: _withCtx(() => [...(_cache[8] || (_cache[8] = []))]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        (_unref(tenantConfig))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", {
                class: _normalizeClass(["w-full max-w-[600px] px-[34px] pb-[100px]", { 'click-to-pay-scroll-content': isClickToPayPreferredModeActive.value }])
              }, [
                _withDirectives(_createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(t)('top_up.country_select')), 1),
                    _createVNode(CountrySelect, {
                      modelValue: _unref(paymentMethodCountry),
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(paymentMethodCountry) ? (paymentMethodCountry).value = $event : null)),
                      availableCountries: _unref(availablePaymentCountries)
                    }, null, 8, ["modelValue", "availableCountries"])
                  ])
                ], 512), [
                  [_vShow, _unref(availablePaymentCountries).length > 1 && _unref(tenantConfig) && _unref(tenantConfig)!.payment_countries.length > 0]
                ]),
                (!_unref(encryptedRfidTag) && !_unref(loginToken) && !_unref(walletId) && topupableWallets.value.length > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(t)('top_up.wallet_select')), 1),
                      _createElementVNode("div", {
                        class: "flex items-center justify-between px-4 py-2 rounded cursor-pointer text-white",
                        onClick: toggleWalletSelect
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_unref(selectedWallet)?.currency.prefix) + " " + _toDisplayString(_unref(selectedWallet)?.currency.name), 1),
                        _createVNode(_unref(IonIcon), { icon: _unref(chevronDownIcon) }, null, 8, ["icon"])
                      ]),
                      _createVNode(_Transition, { name: "dropdown-fade" }, {
                        default: _withCtx(() => [
                          (isWalletSelectOpen.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topupableWallets.value, (w) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: w.id,
                                    class: "flex items-center gap-2 px-4 py-2 hover:bg-white/10 cursor-pointer text-white",
                                    onClick: ($event: any) => (onWalletSelect(w.id.toString()))
                                  }, [
                                    _createElementVNode("span", null, _toDisplayString(w.currency.prefix) + " " + _toDisplayString(w.currency.name), 1)
                                  ], 8, _hoisted_9))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_10, [
                  (_unref(tenantConfig).wallet_enable_packages && _unref(walletPackages) && topUpType.value)
                    ? (_openBlock(), _createBlock(_unref(IonSegment), {
                        key: 0,
                        class: "h-[50px] mb-2 ion-no-margin",
                        value: topUpType.value,
                        mode: "ios"
                      }, {
                        default: _withCtx(() => [
                          (_unref(tenantConfig).wallet_enable_packages)
                            ? (_openBlock(), _createBlock(_unref(IonSegmentButton), {
                                key: 0,
                                class: "ion-no-margin",
                                value: _unref(TopUp).TopUpTypePackages,
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (topUpType.value = _unref(TopUp).TopUpTypePackages))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonLabel), { class: "font-sourcesanspro-semibold text-base2" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(t)('top_up.packages')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"]))
                            : _createCommentVNode("", true),
                          (_unref(tenantConfig).wallet_enable_free_input)
                            ? (_openBlock(), _createBlock(_unref(IonSegmentButton), {
                                key: 1,
                                class: "ion-no-margin",
                                value: _unref(TopUp).TopUpTypeFreeAmount,
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (topUpType.value = _unref(TopUp).TopUpTypeFreeAmount))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonLabel), { class: "font-sourcesanspro-semibold text-base2" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(t)('top_up.free_amount')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["value"]))
                    : _createCommentVNode("", true),
                  (!_unref(countrySelectionValidated) && _unref(availablePaymentCountries).length > 1 && _unref(tenantConfig) && _unref(tenantConfig)!.payment_countries.length > 0 && !isPreferredPaymentModeActive.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('top_up.first_country_selection_title')), 1),
                        _createTextVNode(" " + _toDisplayString(_unref(t)('top_up.first_country_selection')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (isClickToPayPreferredModeActive.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(t)('top_up.click_to_pay.minimum_message')), 1))
                    : _createCommentVNode("", true),
                  (_unref(userProfile) && _unref(tenantConfig).top_up_general_message)
                    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, null, 512)), [
                        [_directive_dompurify_html, _unref(replaceTopUpGeneralMessageVariables)(_unref(tenantConfig).top_up_general_message, _unref(userProfile))]
                      ])
                    : _createCommentVNode("", true)
                ]),
                (!_unref(tenantConfig) || !_unref(minimumTopUp))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(_unref(IonSpinner), { name: "dots" })
                    ]))
                  : _createCommentVNode("", true),
                (topUpType.value === _unref(TopUp).TopUpTypeFreeAmount)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      (_unref(tenantConfig).wallet_enable_free_input)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(fiatCurrency).prefix), 1),
                            _createElementVNode("div", _hoisted_19, [
                              _createVNode(CurrencyInput, {
                                "wrapper-class": "flex flex-wrap justify-left item-center border border-solid focus-within:background-white-15",
                                "input-class": "text-lg",
                                name: "amount",
                                placeholder: "0,00",
                                step: "any",
                                onInputChanged: _unref(onAmountChange),
                                "should-validate": false
                              }, null, 8, ["onInputChanged"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_20, [
                        (Number(_unref(formValue).replace(',', '.')) > 0 && _unref(selectedWallet)?.currency.name !== 'EUR')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(fiatCurrency).prefix) + " " + _toDisplayString(_unref(formValue)) + " = " + _toDisplayString(_unref(selectedWallet)?.currency.prefix) + " " + _toDisplayString((parseFloat(_unref(formValue).replace(',', '.')) / +_unref(selectedWallet)?.currency.exchange_rate!).toFixed(2)), 1),
                              (+_unref(tenantConfig).top_up_cost > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_23, " + " + _toDisplayString(_unref(t)('transaction.administrative_fee').toLowerCase()) + " " + _toDisplayString(_unref(fiatCurrency).prefix) + _toDisplayString(+_unref(tenantConfig).top_up_cost) + " = " + _toDisplayString(_unref(fiatCurrency).prefix) + _toDisplayString((parseFloat(_unref(formValue).replace(',', '.')) + +_unref(tenantConfig).top_up_cost).toFixed(2)), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(minimumAmountError))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_24, [
                              _createTextVNode(_toDisplayString(_unref(t)('balance.errorMinimumAmount')) + " ", 1),
                              (_unref(minimumTopUp)?.amount && parseFloat(_unref(formValue).replace(',', '.')) < _unref(minimumTopUp).amount)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_unref(fiatCurrency).prefix) + " " + _toDisplayString(_unref(minimumTopUp).amount), 1))
                                : (parseFloat(_unref(formValue).replace(',', '.')) < 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_unref(fiatCurrency).prefix) + "1.00 ", 1))
                                  : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(minimumTopUp) && topUpType.value === _unref(TopUp).TopUpTypePackages)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      (_unref(previousTopUp) && _unref(previousTopUp).amount && _unref(minimumAmountError) && _unref(checkIsLatestAmountGreaterThanMinimumAmount)(_unref(minimumTopUp).amount, _unref(previousTopUp).amount))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(t)('balance.minimum_amount')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_31, [
                              _createVNode(_unref(IonButton), { class: "rounded-full bg-white/10 small font-sourcesanspro-regular text-base2 text-white" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, _toDisplayString(_unref(selectedWallet)?.currency.prefix) + _toDisplayString(_unref(convertToCurrency)(_unref(minimumTopUp).amount)), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(walletPackages))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(walletPackages), (walletPackage, index) => {
                              return (_openBlock(), _createBlock(ItemWithContentStandalone, {
                                key: index,
                                "has-description": !!walletPackage.description,
                                icon: require('@/statics/svg/icons/box.svg'),
                                image: walletPackage.image ? walletPackage.image : undefined,
                                title: walletPackage.name,
                                price: +walletPackage.clientx_price_incl_fee > +walletPackage.clientx_price ? _unref(fiatCurrency).prefix + (+walletPackage.clientx_price).toFixed(2) + ' + ' + _unref(t)('transaction.administrative_fee').toLowerCase() : _unref(fiatCurrency).prefix + walletPackage.clientx_price_incl_fee,
                                "is-selected": selectedWalletPackage.value && selectedWalletPackage.value.id == walletPackage.id,
                                variant: isClickToPayPreferredModeActive.value ? 'click_to_pay' : 'default',
                                onOnSelectItem: ($event: any) => (selectPackage(walletPackage))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(walletPackage.description), 1)
                                ]),
                                _: 2
                              }, 1032, ["has-description", "icon", "image", "title", "price", "is-selected", "variant", "onOnSelectItem"]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (isClickToPayPreferredModeActive.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 4,
                      type: "button",
                      class: "click-to-pay-help-row",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (showClickToPayInfoModal.value = true))
                    }, [
                      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "click-to-pay-help-icon" }, [
                        _createElementVNode("span", { "aria-hidden": "true" }, "?")
                      ], -1)),
                      _createElementVNode("span", _hoisted_33, [
                        _createElementVNode("span", _hoisted_34, _toDisplayString(_unref(t)('top_up.click_to_pay.first_time_title')), 1),
                        _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(t)('top_up.click_to_pay.first_time_subtitle')), 1)
                      ]),
                      _createVNode(_unref(IonIcon), {
                        icon: _unref(chevronForwardOutline),
                        class: "ml-auto text-white/80"
                      }, null, 8, ["icon"])
                    ]))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", {
                  class: _normalizeClass(["max-w-[600px] mx-auto px-4 pt-4 pb-[env(safe-area-inset-bottom)]", { 'click-to-pay-actions-inner': isClickToPayPreferredModeActive.value }])
                }, [
                  (isPreferredPaymentModeActive.value)
                    ? (_openBlock(), _createBlock(_unref(IonButton), {
                        key: 0,
                        class: "flex items-center justify-center mb-2 w-full font-sourcesanspro-regular text-white text-sm2 cursor-pointer",
                        shape: "round",
                        fill: "outline",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(switchPreferredPaymentMode)()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('top_up.other_payment_options')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(IonButton), {
                    class: "w-full max-w-none hover:bg-white hover:rounded-full mb-4",
                    expand: "full",
                    size: "large",
                    shape: "round",
                    disabled: (topUpType.value === _unref(TopUp).TopUpTypeFreeAmount && !_unref(enableTopUpSubmitButton)) || (topUpType.value === _unref(TopUp).TopUpTypePackages && !selectedWalletPackage.value),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (topUpType.value === _unref(TopUp).TopUpTypeFreeAmount ? addTopUp() : addTopUpPackage()))
                  }, {
                    default: _withCtx(() => [
                      (!isPreferredPaymentModeActive.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            _createElementVNode("span", null, _toDisplayString(_unref(t)('general.continue')), 1),
                            _createVNode(_unref(IonIcon), {
                              icon: _unref(arrowForwardOutline),
                              class: "text-dark-blue mr-2"
                            }, null, 8, ["icon"])
                          ]))
                        : _createCommentVNode("", true),
                      (isPayconiqPreferredModeActive.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _createElementVNode("span", null, _toDisplayString(_unref(t)('balance.pay_with')), 1),
                            _createElementVNode("img", {
                              class: "w-[94px] h-[31px]",
                              src: require('@/statics/png/payconiq/payconiq-logo-dark.png')
                            }, null, 8, _hoisted_39)
                          ]))
                        : _createCommentVNode("", true),
                      (isClickToPayPreferredModeActive.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            _createElementVNode("span", null, _toDisplayString(_unref(t)('balance.pay_with')), 1),
                            _cache[10] || (_cache[10] = _createElementVNode("span", {
                              class: "mastercard-mark",
                              "aria-hidden": "true"
                            }, [
                              _createElementVNode("span"),
                              _createElementVNode("span")
                            ], -1)),
                            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "font-sourcesanspro-black" }, "Click to Pay", -1))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ], 2)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_unref(IonModal), {
        "is-open": showClickToPayInfoModal.value,
        class: "click-to-pay-info-modal",
        onDidDismiss: _cache[7] || (_cache[7] = ($event: any) => (showClickToPayInfoModal.value = false))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("h2", _hoisted_43, _toDisplayString(_unref(t)('top_up.click_to_pay.modal_title')), 1),
              _createElementVNode("button", {
                type: "button",
                class: "click-to-pay-modal-close",
                "aria-label": "Close",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (showClickToPayInfoModal.value = false))
              }, [
                _createVNode(_unref(IonIcon), { icon: _unref(closeOutline) }, null, 8, ["icon"])
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("h3", null, _toDisplayString(_unref(t)('top_up.click_to_pay.callout_title')), 1),
              _createElementVNode("p", null, _toDisplayString(_unref(t)('top_up.click_to_pay.callout_body')), 1)
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", null, [
                _createElementVNode("h3", null, _toDisplayString(_unref(t)('top_up.click_to_pay.steps.setup_title')), 1),
                _createElementVNode("p", null, _toDisplayString(_unref(t)('top_up.click_to_pay.steps.setup_body')), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("h3", null, _toDisplayString(_unref(t)('top_up.click_to_pay.steps.storage_title')), 1),
                _createElementVNode("p", null, _toDisplayString(_unref(t)('top_up.click_to_pay.steps.storage_body')), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("h3", null, _toDisplayString(_unref(t)('top_up.click_to_pay.steps.other_sites_title')), 1),
                _createElementVNode("p", null, _toDisplayString(_unref(t)('top_up.click_to_pay.steps.other_sites_body')), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("h3", null, _toDisplayString(_unref(t)('top_up.click_to_pay.steps.remove_title')), 1),
                _createElementVNode("p", null, _toDisplayString(_unref(t)('top_up.click_to_pay.steps.remove_body')), 1)
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_46, null, 512), [
              [_directive_dompurify_html, _unref(t)('top_up.click_to_pay.powered_by')]
            ])
          ])
        ]),
        _: 1
      }, 8, ["is-open"])
    ]),
    _: 1
  }, 8, ["style", "class"]))
}
}

})